<template>
<div id="stats-view">
  <v-dialog transition="dialog-bottom-transition" hide-overlay v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title class="headline">
        {{$t('stats.stat')}}: {{form.name}}
      </v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-text-field v-model="form.name" :label="`${$t('cyclic.name')}`" :readonly="!edit" required></v-text-field>

          <v-textarea v-model="form.formule" :label="`${$t('stats.formule')}`" :readonly="!edit" required></v-textarea>

          <v-select v-model="form.type" item-text="name" item-value="type" :readonly="!edit" :items="types" :label="`${$t('stats.type')}`"> </v-select>
          <v-select v-model="form.schema_id" :label="`${$t('stats.schema')}`" :readonly="!edit" item-text="name" item-value="id" :items="schemas" required></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="close()">
          {{$t('stats.close')}}
        </v-btn>
        <v-btn v-if="edit" color="blue darken-1" text @click="update()">
          {{$t('stats.update')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import http from '@/plugins/http'


export default {
  components: {},
  props: ['formData', 'dialog', 'edit', 'schemas'],
  data() {
    return {
      form: {}
    }
  },
  computed: {
    types() {
      return [{
          "type": "line",
          "name": this.$t('stats.charts.line')
        }, {
          "type": "bar",
          "name": this.$t('stats.charts.bar')
        },
        {
          "type": "stackedbar",
          "name": this.$t('stats.charts.stacked_bar')
        }, {
          "type": "column",
          "name": this.$t('stats.charts.column')
        }
      ]
    }
  },
  methods: {
    close() {
      this.$emit('closeFullView')
    },
    update() {
      this.$emit('update', this.form)
    },
  },
  created() {
    this.form = {
      ...this.formData
    }
  }
}
</script>

<style>

</style>
